import { Link } from 'react-router-dom';

const Footer = () => {
  const scrollToSection = (id: string) => {
    window.location.href = `/#${id}`;
  };

  return (
    <footer className="bg-[#E6007E] text-white py-16">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Logo & Mission */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <h3 className="font-poppins font-bold text-3xl">MASDEUNA</h3>
            </div>
            <p className="font-inter text-white/90 text-lg leading-relaxed mb-6">
              Empowering Latina leaders through mentorship, professional development, and community support.
            </p>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-2xl"></i>
              </a>
              <a
                href="https://www.twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-gray-900 mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/mas-academy" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  MAS Academy
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/join" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Join Us
                </Link>
              </li>
              <li>
                <Link to="/donate" className="text-gray-600 hover:text-teal-600 transition-colors cursor-pointer">
                  Donate
                </Link>
              </li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-poppins font-bold text-xl mb-6">Get Involved</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://docs.google.com/forms/d/e/1FAIpQLSe2AFw3euLY3qYKJx3BfxedFvlkB3ep__CSb3rwIBXWKWtxiA/viewform"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-inter text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Become a Mentee
                </a>
              </li>
              <li>
                <a
                  href="https://forms.gle/iQmn9h9gtcXQJePe8"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-inter text-white/90 hover:text-white transition-colors cursor-pointer"
                >
                  Become a Mentor
                </a>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="font-inter text-white/90 hover:text-white transition-colors cursor-pointer">
                  Contact Us
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="font-inter text-white/80 text-center md:text-left">
              © {new Date().getFullYear()} MasDeUna. All rights reserved. | <a href="mailto:Julie@MasDeUna.Org" className="hover:text-white transition-colors">Julie@MasDeUna.Org</a>
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="font-inter text-white/80 hover:text-white transition-colors text-sm"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
